import React from "react";
import ButtonGroup from "./buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-light-svg-icons";
import { getSingleCharDayName } from "../../utils";
import FileStatusTableRow from "./FileStatusTableRow";
// import fileStatusData from "../../mocks/FileStatusData";

const FileStatusTable = (props) => {
  const PAYROLL_FILE_STATUS_DATA = {
    0: "All",

    1: "Creation in progress",

    2: "Upload in progress",

    3: "Error Correction Required",

    4: "Pending Submission",

    5: "Awaiting Funding",

    6: "Awaiting Trade",

    7: "Completed",

    8: "Cancelled",

    9: "Deleted",

    12: "Error in File Processor",

    13: "SystemFailure",

    14: "Awaiting Fund Confirmation",

    15: "Payroll Funded",

    16: "Funding Failed",
  };
  let fileData = props.data;
  var total = fileData.reduce(function (tot, arr) {
    // return the sum with previous value
    return tot + arr.fileCount;
    // set initial value as 0
  }, 0);

  let ErrorCorrObj = fileData.find(
    (obj) =>
      obj.fileStatus == "Error Correction Required" || obj.fileStatus == 3
  );
  const ErrorCorrectionVal = ErrorCorrObj.fileCount;

  let fileData2 = fileData.map((item, idx) => {
    return {
      fileStatus: PAYROLL_FILE_STATUS_DATA[item.fileStatus],
      fileCount: item.fileCount,
      percentage: item.fileCount / total,
    };
  });

  const myStyle = {
    whiteSpace: "nowrap",
    width: "100%",
    padding: "8px",
    marginTop: "10px",
  };
  const styleColumnNames = {
    borderTopWidth: "2px",
    borderBottomWidth: "2px",
  };
  const styleColumnNamesForBar = {
    borderTopWidth: "2px",
    borderBottomWidth: "2px",
    width: "100%",
  };
  const maxPercentageItem = fileData2.reduce((prev, current) => {
    return prev.percentage > current.percentage ? prev : current;
  });
  const maxPercentage = maxPercentageItem.percentage;

  console.log("fileData is ", fileData2);

  // {console.log( "inside fileStatus Table",props, typeof(props), "fileData is" , fileData)}
  return (
    <>
      <ButtonGroup
        font="Arial"
        color={["grey", "#D65260", "#C1935C", "#409550"]}
        fontSize={0.2}
        borderRadius={6}
        borderColor="transparent"
        backgroundColor={["white", "#F9E7E9", "#F6EFE7", "#E7F1E9"]}
        description={[
          "Total Count",
          "Error Corrections",
          "Pending Submissions",
          "Awaiting Funding",
        ]}
        count={[total, ErrorCorrectionVal, 0, 5]}
      />
      <table className="table table-borderless" style={myStyle}>
        <thead>
          <tr>
            <th scope="col" style={styleColumnNames}>
              File Status
            </th>
            <th scope="col" style={styleColumnNames}>
              Count
            </th>
            <th scope="col" style={styleColumnNamesForBar}>
              &nbsp;
            </th>
          </tr>
        </thead>
        <tbody>
          {fileData2.map((fileStatusDataItem) =>
            FileStatusTableRow(fileStatusDataItem, maxPercentage)
          )}
        </tbody>
      </table>

      {console.log(total)}
    </>
  );
};

export default FileStatusTable;
